import { useEffect, useState } from 'react';

const useDebouncedValue = (valor, ms) => {
  const [diferido, setDiferido] = useState(valor);

  useEffect(() => {
    const id = setTimeout(() => setDiferido(valor), ms);
    return () => clearTimeout(id);
  }, [valor, ms]);

  return diferido;
};

export default useDebouncedValue;
